import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { companyDataStateSelector } from '~/selectors';

import { CompanyData } from './types';

export const useCompanyData = (): {
  companyData: CompanyData;
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
} => {
  return useSelector((state: StoreState) => {
    return companyDataStateSelector(state);
  });
};
